
export function CalculatorHero() {
  return (
    <section className="relative pt-12 pb-8 bg-gradient-to-br from-[#F0F0F0] via-white to-[#F0F0F0]">
      <div className="max-w-5xl mx-auto px-6 text-center">
        <div className="inline-block bg-[#882629]/10 text-[#882629] text-xs font-semibold px-4 py-1.5 rounded-full mb-5 tracking-wide">
          FREE REVENUE ESTIMATOR
        </div>
        <h1 className="font-['Fraunces'] text-3xl lg:text-5xl font-bold text-[#505A5A] leading-tight mb-4">
          How much could your property earn on Airbnb?
        </h1>
        <p className="text-base lg:text-lg text-[#505A5A]/70 leading-relaxed max-w-2xl mx-auto">
          Adjust the sliders below to get a real-time estimate of your monthly short-term rental revenue based on your property details and location.
        </p>
      </div>
    </section>
  );
}
